import FlashLib from 'flashlib_onlyplay';
import eGameMode from '../enums/eGameMode';
import animationCreator from 'Engine/animations/animationCreator';
import eAnimationTypes from '../enums/eAnimationTypes';

export default class ControllerSlotBackground extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
    this.init();
  }

  init() {
    // this.ControllerSlotsLight = this.getChildByName('light');
    // this.ControllerSlotsLight.playAnimation(this.ControllerSlotsLight.animationTypes.CIRCLE, 400000, 1500, 0, true);
  }

  playWinAnimation() {
    // this.ControllerSlotsLight.playAnimation(this.ControllerSlotsLight.animationTypes.BLINK, 20000, 200, 0, true);
  }

  playWaitAnimation() {
    // this.ControllerSlotsLight.playAnimation(this.ControllerSlotsLight.animationTypes.SNAKE, 3000, 4000, 60, false, 3);
  }
}
